export default __webpack_public_path__ + "static/media/WarLeaderboard.ae17a69c.png";